module.exports = __webpack_public_path__ + "img/switzerland-other-heart-diseases-female.08ec385d.png";